<template>
    <div>

         <CustomModal v-if="isModalOpen" ref="customModal" :modalId="modalId" :isOpen="isModalOpen" :showFooter="true" @modalClosed="modalClosed" :isStyle="'max-width:100% !important;'">
            
            <template #header>
                <h5 class="modal-title">{{['create','transfer'].includes(action) ? $t('create_order') : $t('edit_order') }}</h5>
                <small v-if="isDraftAutosaveEnabled && draftAutosaveState !== 'idle'" class="ms-auto me-3 text-muted d-flex align-items-center">
                    <span v-if="draftAutosaveState === 'saving'" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                    <AppIcon name="bi-cloud-check" v-else-if="draftAutosaveState === 'saved'" class="bi bi-cloud-check me-1 text-success" />
                    <AppIcon name="bi-cloud-slash" v-else-if="draftAutosaveState === 'error'" class="bi bi-cloud-slash me-1 text-danger" />
                    <AppIcon name="bi-cloud-arrow-up" v-else class="bi bi-cloud-arrow-up me-1" />
                    {{ draftAutosaveStatusLabel }}
                </small>
                <button type="button" id="close-modal-btn" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="modalClosed"></button>
            </template>

            <template #body>
                <div style="text-align:left">
                        <div class="row">
                            <div class="col-6 col-sm-6">
                                <div class="mb-3">
                                    <label for="exampleFormControlInput1"  class="form-label">{{$t('reference')}}</label>
                                    <input v-model="localData.reference" type="string" class="form-control" id="exampleFormControlInput1" placeholder="Reference">
                                </div>
                            </div>
                            <div class="col-6 col-sm-6">
                                <div class="mb-3">
                                <label for="exampleFormControlInput1" class="form-label">{{$t('date')}}</label>
                                <input v-model="localData.date" type="date" class="form-control" id="exampleFormControlInput1" placeholder="Reference Date">
                            </div>
                            </div>
                        </div>

                        <hr>
                        
                        <!-- product -->
                        <div class="mb-3">
                            <div class="">
                            <div v-for="(prd,i) in localData.products" :key="i" class="row mb-3">
                                <!-- Product selector: full width on mobile, compact on sm+ -->
                                <div class="col-12 col-xl-5">
                                    <div class="d-flex align-items-center">
                                        <div class="form-check form-switch">
                                            <input
                                                class="form-check-input"
                                                type="checkbox"
                                                id="paymentToggle"
                                                v-model="localData.products[i].custom_product"
                                            >
                                        </div>
                                        <label for="paymentToggle" class="form-label toggle-label me-3">{{localData.products[i].custom_product ? $t('custom_product') : $t('existing_product') }}</label>
                                    </div>

                                    <div class="d-flex">
                                        <div class="flex-grow-1">
                                            <auto-complete  
                                                    :uid="i"
                                                    v-if="!localData.products[i].custom_product && createClientState === false" 
                                                    @emitAutoComplete="emitAutoComplete" 
                                                    :defaultValue="localData.products[i].product_label" 
                                                    entity="inventories"
                                                    emitEvent="emitAutoComplete"
                                                    :dislaySuggestions="action =='create' ? true : false " 
                                                ></auto-complete>
                                                <div v-if="localData.products[i].variants && localData.products[i].variants.length" class="mt-2">
                                                    <select class="form-select form-select-sm" v-model="localData.products[i].variant_id" @change="onVariantChange(i)">
                                                        <option :value="null" disabled>Select Variant</option>
                                                        <option v-for="variant in localData.products[i].variants" :key="variant.id" :value="variant.id">
                                                            {{ variant.name }}
                                                        </option>
                                                    </select>
                                                </div>
                                                <product-rich-text-editor
                                                    v-if="localData.products[i].custom_product"
                                                    v-model="localData.products[i].product_label"
                                                    :placeholder="$t('product_label')"
                                                ></product-rich-text-editor>
                                                <div v-if="localData.products[i].custom_product && canCreateCatalogProducts" class="form-check mt-2">
                                                    <input
                                                        v-model="localData.products[i].create_catalog_product"
                                                        class="form-check-input"
                                                        type="checkbox"
                                                        :id="'orderCreateCatalogProduct' + i"
                                                    >
                                                    <label class="form-check-label" :for="'orderCreateCatalogProduct' + i">
                                                        {{ $t('also_add_to_products') }}
                                                    </label>
                                                </div>
                                                <div v-if="localData.products[i].product_id && (localData.products[i].maxQty <= 0)" class="text-danger small mt-1">
                                                    <AppIcon name="bi-exclamation-triangle-fill" class="bi bi-exclamation-triangle-fill me-1" /> {{ $t('product_out_of_stock_warning') }}
                                                </div>
                                        </div>
                                        <button type="button" class="btn line-item-delete-button ms-2 d-block d-sm-none align-self-start" :aria-label="$t('delete')" :title="$t('delete')" @click="removeRow(i)">
                                            <AppIcon name="bi-trash" class="bi bi-trash" />
                                        </button>
                                    </div>
                                </div>
                                <!-- Price -->
                                <div class="col-4 col-xl-1" v-if="localData.products[i].product_id || localData.products[i].custom_product == true">
                                    <label for="exampleFormControlInput1" class="form-label">{{$t('price')}}</label>
                                    <input v-model="localData.products[i].price" @focus="handleInputFocus(localData.products[i], 'price')" @blur="handleInputBlur(localData.products[i], 'price', i)" @change="calculatePrices" class="form-control" placeholder="Price" type="number">                                
                                </div>
                                <!-- Qty -->
                                <div class="col-4 col-xl-1" v-if="localData.products[i].product_id || localData.products[i].custom_product == true">
                                    <label for="exampleFormControlInput1" class="form-label">{{$t('qty')}}</label> 
                                    <select v-if="!localData.products[i].custom_quantity_mode" class="form-select" :value="Number(localData.products[i].quantity)" @change="onQuantityChange(i, $event)">
                                        <option :value="0">0</option>
                                        <option :value="1">1</option>
                                        <option :value="2">2</option>
                                        <option :value="3">3</option>
                                        <option :value="4">4</option>
                                        <option :value="5">5</option>
                                        <option :value="6">6</option>
                                        <option :value="7">7</option>
                                        <option :value="8">8</option>
                                        <option :value="9">9</option>
                                        <option :value="10">10</option>
                                        <option value="custom">Custom</option>
                                    </select>
                                    <div v-else class="input-group">
                                        <input v-model="localData.products[i].quantity" @focus="handleInputFocus(localData.products[i], 'quantity')" @blur="handleInputBlur(localData.products[i], 'quantity', i)" @change="calculatePrices" class="form-control" min="0" type="number" step="any" inputmode="decimal" >
                                        <button class="btn btn-outline-secondary" type="button" @click="switchToSelectMode(i)" style="padding: 0 5px;">
                                            <AppIcon name="bi-list" class="bi bi-list" />
                                        </button>
                                    </div>
                                </div>
                                <!-- VAT -->
                                <div class="col-4 col-xl-1" v-if="localData.products[i].product_id || localData.products[i].custom_product == true">
                                    <label for="exampleFormControlInput1" class="form-label">{{$t('vat')}} %</label>
                                    <select v-if="!localData.products[i].custom_vat_mode" class="form-select" :value="Number(localData.products[i].vat)" @change="onVatChange(i, $event)">
                                        <option :value="0">0%</option>
                                        <option :value="5">5%</option>
                                        <option :value="10">10%</option>
                                        <option :value="20">20%</option>
                                        <option :value="30">30%</option>
                                        <option value="custom">Custom</option>
                                    </select>
                                    <div v-else class="input-group">
                                        <input v-model.number="localData.products[i].vat" @focus="handleInputFocus(localData.products[i], 'vat')" @blur="handleInputBlur(localData.products[i], 'vat', i)" @change="calculatePrices" class="form-control" min="0" max="100" type="number" step="0.01" inputmode="decimal" pattern="[0-9]+(\.[0-9]{1,2})?" >
                                        <button class="btn btn-outline-secondary" type="button" @click="switchToVatSelectMode(i)" style="padding: 0 5px;">
                                            <AppIcon name="bi-list" class="bi bi-list" />
                                        </button>
                                    </div>
                                </div>
                                <!-- Subtotal -->
                                <div class="col-4 col-xl-1" v-if="localData.products[i].product_id || localData.products[i].custom_product == true">
                                    <label for="exampleFormControlInput1" class="form-label">{{$t('sub_total')}}: </label>
                                    <input v-model="localData.products[i].sub_total" @focus="handleInputFocus(localData.products[i], 'sub_total')" @blur="handleInputBlur(localData.products[i], 'sub_total', i)" class="form-control" min="0" max="100" type="number" step="0.01" inputmode="decimal"  >
                                </div>
                                <!-- Discount -->
                                <div class="col-4 col-xl-1" v-if="localData.products[i].product_id || localData.products[i].custom_product == true">
                                    <label for="exampleFormControlInput1" class="form-label">{{$t('discount')}} %</label>
                                    <select v-if="!localData.products[i].custom_discount_mode" class="form-select" :value="Number(localData.products[i].discount)" @change="onDiscountChange(i, $event)">
                                        <option :value="0">0%</option>
                                        <option :value="5">5%</option>
                                        <option :value="10">10%</option>
                                        <option :value="15">15%</option>
                                        <option :value="20">20%</option>
                                        <option :value="25">25%</option>
                                        <option :value="30">30%</option>
                                        <option :value="50">50%</option>
                                        <option value="custom">Custom</option>
                                    </select>
                                    <div v-else class="input-group">
                                        <input v-model="localData.products[i].discount" @focus="handleInputFocus(localData.products[i], 'discount')" @blur="handleInputBlur(localData.products[i], 'discount', i)" @change="calculatePrices" class="form-control"  min="0" max="100" type="number" step="0.01" inputmode="decimal">
                                        <button class="btn btn-outline-secondary" type="button" @click="switchToDiscountSelectMode(i)" style="padding: 0 5px;">
                                            <AppIcon name="bi-list" class="bi bi-list" />
                                        </button>
                                    </div>
                                </div>
                                <!-- Total -->
                                <div class="col-4 col-xl-1" v-if="localData.products[i].product_id || localData.products[i].custom_product == true">
                                    <label for="exampleFormControlInput1" class="form-label">{{$t('total')}}: </label>
                                    <input v-model="localData.products[i].total" @focus="handleInputFocus(localData.products[i], 'total')" @blur="handleInputBlur(localData.products[i], 'total', i)" class="form-control" @change="parseTTctoHt(i,localData.products[i].total)"  min="0" type="number" step="0.01" inputmode="decimal" >
                                </div>
                                <!-- Remove button -->
                                <div class="col-12 col-xl-1 d-none d-sm-block"  style="margin-top:25px">
                                    <button type="button" class="mb-3 btn line-item-delete-button" :aria-label="$t('delete')" :title="$t('delete')" @click="removeRow(i)"><AppIcon name="bi-trash" class="bi bi-trash" /></button>
                                </div>
                                <div class="col-12 d-block d-sm-none">
                                    <hr>
                                </div>
                            </div>  
                            </div>

                            <div class="row">
                                <div class="col-sm-9 btn-add-product">
                                    <button type="button" class="mb-3 btn btn-success btn-sm" @click="addNewRow"><PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" /> {{$t('product')}}</button>
                                </div>
                                <div class="col-sm-3 d-none d-sm-block" v-if="checkIfValidProduct()">
                                    <span>{{$t('sub_total')}} : <b>{{formatMoney(sub_total)}} </b> <br></span>
                                    <span>{{$t('vat')}} : <b>{{formatMoney(totalTvaPrice())}} </b></span> <br>
                                    <span v-if="total_discounted && total_discounted > 0">{{$t('discount')}} : <b>- {{formatMoney(total_discounted)}} </b> <br></span>
                                    <span>{{$t('total')}} : <b>{{ formatMoney(total) }} </b> <br></span>
                                </div>
                            </div>
                            
                        </div>
                        <!-- product -->

                        <hr>
                        <div class="row">

                             <div class="col-6 col-sm-3">
                            <label for="exampleFormControlInput1" class="form-label"><strong>{{$t('client')}}</strong></label>

                            <auto-complete  
                                    v-if="createClientState === false" 
                                    @emitAutoCompleteClient="emitAutoCompleteClient" 
                                    :defaultValue="localData.client ? localData.client.name : ''"
                                    entity="clients"
                                    emitEvent="emitAutoCompleteClient"
                            ></auto-complete>
                                <a href="#" class="related-create-link d-block mt-1 small text-decoration-none" @click.prevent="openCreateClientModal">
                                    <AppIcon name="bi-plus-circle" class="bi bi-plus-circle me-1" />{{$t('create_new_client')}}
                                </a>
                        </div>
                            <div class="col-6 col-sm-2">
                                <label for="exampleFormControlInput1" class="form-label">
                                    {{$t('status')}}
                                </label>
                                <select v-model="localData.status" class="form-select" aria-label="Default select example">
                                    <option selected value="pending">{{$t('pending')}}</option>
                                    <option value="confirmed">{{$t('confirmed')}}</option>
                                </select>
                            </div>

                        </div>
                       

                        <div class="mb-3">
                            <collapsible-notes-field v-model="localData.notes" id="order-notes" rows="1" />
                        </div>

                        <!-- <div class="mb-3">
                            
                            <span v-if="checkIfValidProduct()" @click="invoiceModalisOpen = true" style="cursor:pointer">
                                <AppIcon name="bi-eye" class="bi bi-eye" style="font-size:12px" />
                                <small>&nbsp;{{$t('preview')}}</small>
                            </span>
                            
                        </div> -->

                    </div>

                    <div class="alert alert-warning" role="alert" v-if="msgError">
                    {{msgError}}
                </div>
            </template>

            <template #footer>
                <!-- Mobile totals in footer -->
                <div class="mobile-totals d-block d-sm-none text-start me-auto" v-if="checkIfValidProduct()" style="font-size: 0.75rem;">
                    <div><small>{{$t('sub_total')}}:</small> <b>{{ formatMoney(sub_total) }}</b></div>
                    <div><small>{{$t('vat')}}:</small> <b>{{ formatMoney(totalTvaPrice()) }}</b></div>
                    <div v-if="total_discounted && total_discounted > 0"><small>{{$t('discount')}}:</small> <b>- {{ formatMoney(total_discounted) }}</b></div>
                    <div><small>{{$t('total')}}:</small> <b>{{ formatMoney(total) }}</b></div>
                </div>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"><AppIcon name="bi-x-lg" class="bi bi-x-lg me-1" />{{$t('close')}}</button>
                <button v-if="action == 'update'" type="button" class="btn btn-success" @click="updateRow" :disabled="!checkIfValidProduct() || loading">
                    <AppIcon name="bi-pencil" class="bi bi-pencil" style="font-size:12px" />
                    {{$t('edit')}}
                </button>
                <button v-if="['create','transfer'].includes(action)" type="button" class="btn btn-success" @click="saveRow" :disabled="!checkIfValidProduct() || loading"><AppIcon name="bi-check-circle" class="bi bi-check-circle me-2" />{{$t('create')}}</button>
            </template>

        </CustomModal>

        <!-- client modal -->
        <add-client 
            v-if="createClientState"  
            :state="createClientState"  
            @createClient="createClient"
        />
        <!-- client modal -->


        <!-- invoice modal -->
        <invoice-template-modal 
            v-if="invoiceModalisOpen" 
            @modalClosed="invoiceModalisOpen = false" 
            modalId="invoice-order-modal-22" 
            :isModalOpen="invoiceModalisOpen"  
            :data="data" 
            type="order">
        </invoice-template-modal>
        <!-- invoice modal -->

    </div>
   
    
    
</template>

<script>
import CustomModal from '../CustomModal.vue'
import helper from '../../helper'
import AutoComplete from '../autocomplete/AutoComplete'
import AddClient from '../AddClient.vue'
import InvoiceTemplateModal from '../invoiceLayout/InvoiceTemplateModal.vue'
import ProductRichTextEditor from '../common/ProductRichTextEditor.vue'
import draftAutosave from '../../mixins/draftAutosave'
import moment from 'moment'

export default {
  name: 'AddEditOrderModal',
  mixins: [draftAutosave],
  props : {
        action: {
            type: String,
            required: true
        },
        data: {
            default: false
        },
        isModalOpen: {
            type: Boolean,
            default: false
        },
        modalId : {
            type : String,
            default : 'exampleModal'
        }
  },
  components : {
    CustomModal,
    AutoComplete,
    AddClient,
    InvoiceTemplateModal,
    ProductRichTextEditor
  },
  data(){
    return {
        loading : false,
        invoiceModalStatus : false,
        invoiceModalisOpen :false,
        createClientState : false,
        hideClient : false,
        localData: JSON.parse(JSON.stringify(this.data)),
        msgError : null
    }
  },
  computed : {
    business(){ return this.$store.getters.BUSINESS},
    isProductModuleEnabled(){ return helper.checkModuleIsEnabled('products') },
    canCreateCatalogProducts(){
        return this.isProductModuleEnabled
            && this.business?.metadata?.allow_custom_product_catalog_creation === true
            && ![-1, -2].includes(helper.checkAccess('create_inventories'))
    },
    total(){ return this.localData.products.length ? this.localData.products.map(o => o.total).reduce((a, c) => { return parseFloat(a) + parseFloat(c) }) : 0},
    sub_total(){ return this.localData.products.length ? this.localData.products.map(o => o.sub_total).reduce((a, c) => { return parseFloat(a) + parseFloat(c) }) : 0},
    total_discounted(){ return this.localData.products.length ? this.localData.products.map(o => o.total_discount).reduce((a, c) => { return parseFloat(a) + parseFloat(c) }) : 0},
  },
  methods : {
    draftAutosaveResource(){ return 'orders' },
    async saveRow(){
        try{
            this.loading = true
            this.msgError = ''

            if (this.business?.metadata?.strict_stock_mode) {
                 const outOfStockProducts = this.localData.products.filter(p => p.product_id && (p.maxQty === undefined || p.maxQty <= 0) && !p.custom_product);
                 if (outOfStockProducts.length > 0) {
                     this.msgError = this.$t('cannot_create_order_out_of_stock');
                     this.loading = false;
                     window.vueOpener.open({
                        message: this.msgError,
                        type: 'warning',
                        position: 'bottom'
                    });
                    return;
                 }
            }

            this.sanitizeCustomProductLabels()

            if(!this.localData.client_id && this.localData.client && this.localData.client.id ){
                this.localData.client_id = this.localData.client.id
            }

            
            // Do not divide price on save to avoid compound division bug
            for(let i = 0 ; i < this.localData.products.length ; i++){
                if(this.localData.products[i].quantity == 0){
                    this.msgError += `${this.$t('product')}: [${helper.richTextToPlainText(this.localData.products[i].product_label)}] ${this.$t('quantity')} :[${this.localData.products[i].quantity}] \n`
                }
            }

            if(!this.localData.products.length){
                this.msgError = `No Product Found`
            }

            if(this.msgError) {
                this.loading = false
                window.vueOpener.open({
                    message: this.msgError,
                    type: 'warning',
                    position: 'bottom'
                });
                return
            }

            await helper.createCatalogProductsFromCustomRows(this.localData.products)

            //format products
            this.localData.products = helper.formatProducts(this.localData.products, true)

            // Update the existing draft instead of creating a new one
            this.localData.status = 'pending'
            await this.pauseDraftAutosave()
            const response = await helper.customPatch(`${process.env.VUE_APP_API}/orders/${this.localData.id}`,{...this.localData },{showToast:true})
            //confirm quote if exists
            if(this?.localData?.quote_id){
                await helper.customPatch(`${process.env.VUE_APP_API}/quotes/${this.localData.quote_id}`,{ status : 'confirmed', order_id : this.localData.id },{showToast:false})
            }
            // Confirm multiple quotes if bulk transfer
            if(this?.localData?.quote_ids && Array.isArray(this.localData.quote_ids)){
                 await Promise.all(this.localData.quote_ids.map(id => 
                    helper.customPatch(`${process.env.VUE_APP_API}/quotes/${id}`,{ status : 'confirmed', order_id : this.localData.id },{showToast:false})
                 ));
            }
            this.clearForm()
            this.loading = false
            

            this.modalClosed()
            this.$router.push({path : `/orders/${response.data.id}`})
        }catch(error){
            this.resumeDraftAutosave()
            this.loading = false
        }
    },
    async updateRow(){
        try{
            this.loading = true
            this.msgError = ''

            if (this.business?.metadata?.strict_stock_mode) {
                 const outOfStockProducts = this.localData.products.filter(p => p.product_id && (p.maxQty === undefined || p.maxQty <= 0) && !p.custom_product);
                 if (outOfStockProducts.length > 0) {
                     this.msgError = this.$t('cannot_create_order_out_of_stock');
                     this.loading = false;
                     window.vueOpener.open({
                        message: this.msgError,
                        type: 'warning',
                        position: 'bottom'
                    });
                    return;
                 }
            }

            this.sanitizeCustomProductLabels()

            if(!this.localData.client_id && this.localData.client && this.localData.client.id ){
                this.localData.client_id = this.localData.client.id
            }

            
            // Do not divide price on update to avoid compound division bug
            for(let i = 0 ; i < this.localData.products.length ; i++){
                if(this.localData.products[i].quantity == 0){
                    this.msgError += `${this.$t('product')}: [${helper.richTextToPlainText(this.localData.products[i].product_label)}] ${this.$t('quantity')} :[${this.localData.products[i].quantity}] \n`
                }
            }

            if(!this.localData.products.length){
                this.msgError = `No Product Found`
            }

            if(this.msgError) {
                this.loading = false
                window.vueOpener.open({
                    message: this.msgError,
                    type: 'warning',
                    position: 'bottom'
                });
                return
            }

            await helper.createCatalogProductsFromCustomRows(this.localData.products)

            //format products
            this.localData.products = helper.formatProducts(this.localData.products, true)

            await this.pauseDraftAutosave()
            await helper.customPatch(`${process.env.VUE_APP_API}/orders/${this.localData.id}`,{...this.localData })
            this.loading = false
            this.clearForm()
            this.modalClosed()
            this.$emit('refresh',true)
            
        }catch(error){
            this.resumeDraftAutosave()
            this.loading = false
        }
    },
    clearForm(){
        this.localData = {
            id : null,
            reference : '',
            client_id : null,
            client : {},
            date : '',
            total : 0,
            products : []
        }

    },
    addNewRow(){
        this.localData.products.push({
            id : null,
            label : '',
            product_label : '',
            quantity : 0,
            price : 0,
            discount : 0,
            vat :  this.business.vat,
            total : 0,
            sub_total : 0,
            custom_product : false,
            create_catalog_product : false,
            custom_quantity_mode : false,
            custom_discount_mode : false,
            custom_vat_mode : false,
            variants: [],
            variant_id: null
        })
    },
    removeRow(i){
       this.localData.products.splice(i, 1);
    },
    onQuantityChange(index, event) {
        const val = event.target.value;
        if (val === 'custom') {
            this.localData.products[index].custom_quantity_mode = true;
        } else {
            this.localData.products[index].custom_quantity_mode = false;
            this.localData.products[index].quantity = Number(val);
            this.calculatePrices();
        }
    },
    switchToSelectMode(index) {
        this.localData.products[index].custom_quantity_mode = false;
        this.localData.products[index].quantity = 0;
        this.calculatePrices();
    },
    onDiscountChange(index, event) {
        const val = event.target.value;
        if (val === 'custom') {
            this.localData.products[index].custom_discount_mode = true;
        } else {
            this.localData.products[index].custom_discount_mode = false;
            this.localData.products[index].discount = Number(val);
            this.calculatePrices();
        }
    },
    switchToDiscountSelectMode(index) {
        this.localData.products[index].custom_discount_mode = false;
        this.localData.products[index].discount = 0;
        this.calculatePrices();
    },
    onVatChange(index, event) {
        const val = event.target.value;
        if (val === 'custom') {
            this.localData.products[index].custom_vat_mode = true;
        } else {
            this.localData.products[index].custom_vat_mode = false;
            this.localData.products[index].vat = Number(val);
            this.calculatePrices();
        }
    },
    switchToVatSelectMode(index) {
        this.localData.products[index].custom_vat_mode = false;
        this.localData.products[index].vat = 0;
        this.calculatePrices();
    },
    handleInputFocus(row, field){
        if(row[field] == 0){
            row[field] = ''
        }
    },
    handleInputBlur(row, field, index){
        if(row[field] === '' || row[field] === null || row[field] === undefined){
            row[field] = 0
            if(field === 'total'){
                this.parseTTctoHt(index, 0)
            }else if(['price','quantity','vat','discount'].includes(field)){
                this.calculatePrices()
            }
        }
    },
    calculatePrices() {
      this.msgError = null;
      this.$forceUpdate();

      for (let i = 0; i < this.localData.products.length; i++) {
        let product = this.localData.products[i];

        const qty = Number(product.quantity) || 0;
        const price = Number(product.price) || 0;
        const discountRate = Number(product.discount) || 0;
        const vatRate = Number(product.vat) || 0;

        // Derive unit HT depending on configuration
        let unitPriceHT = 0;
        const productPriceIncludesTax = (product.price_includes_tax === true) || (product.product?.price_includes_tax === true) || (this.business?.price_includes_tax === true);
        if (productPriceIncludesTax) {
          unitPriceHT = vatRate > 0 ? price / (1 + vatRate / 100) : price;
        } else {
          unitPriceHT = price;
        }

        // Subtotal (HT) before discount
        const subTotalHT = unitPriceHT * qty;
        product.sub_total = Math.round(subTotalHT * 100) / 100;

        // Discount (applied on HT)
        const discountAmount = product.sub_total * (discountRate / 100);
        product.total_discount = Math.round(discountAmount * 100) / 100;

        // VAT is applied on the discounted HT base
        const vatBase = product.sub_total - product.total_discount;
        const tvaAmount = vatRate > 0 ? vatBase * (vatRate / 100) : 0;

        // Final total TTC
        product.total = Math.round((vatBase + tvaAmount) * 100) / 100;
      }

      // Global total
      this.localData.total = this.localData.products.length ? this.localData.products.map(o => o.total).reduce((a, c) => a + c, 0): 0;
    },
    totalTvaPrice() {
      let total = 0;
      if (this.localData && this.localData.products.length) {
        for (let i = 0; i < this.localData.products.length; i++) {
          const p = this.localData.products[i];
          const vatRate = Number(p.vat) || 0;
          const subHT = Number(p.sub_total) || 0;
          const discount = Number(p.total_discount) || 0;
          const vatBase = Math.max(subHT - discount, 0);
          total += (vatRate / 100) * vatBase;
        }
      }
      return Math.round(total * 100) / 100;
    }, 
    parseTTctoHt(index, price) {
      if(price === '') return
      const prd = this.localData.products[index];
      const qty = Number(prd?.quantity) || 0;
      const vatRate = Number(prd?.vat) || 0;
      if (price && price > 0 && qty > 0) {
        const unitTTC = Number(price) / qty;
        const productPriceIncludesTax = (prd.price_includes_tax === true) || (prd.product?.price_includes_tax === true) || (this.business?.price_includes_tax === true);
        if (productPriceIncludesTax) {
          // Price field is TTC when business or product prices include tax
          prd.price = unitTTC.toFixed(2);
        } else {
          // Price field is HT when business and product prices exclude tax
          prd.price = (vatRate > 0 ? unitTTC / (1 + vatRate / 100) : unitTTC).toFixed(2);
        }
        // Update HT subtotal
        const unitHT = productPriceIncludesTax
          ? (vatRate > 0 ? unitTTC / (1 + vatRate / 100) : unitTTC)
          : Number(prd.price);
        prd.sub_total = Math.round((unitHT * qty) * 100) / 100;
      }
    },
    emitAutoComplete(data){
        if(!this.localData.products.length || !this.localData.products.find(product => product.product_id == data.result.product.id)){
            this.localData.products[data.index] = {
                ...{
                inventory_id : data.result.id,
                product_id : data.result.product.id,
                label : data.result.product.label,
                product_label : data.result.product.label,
                // id : data.result.product.id,
                quantity : 0,
                maxQty : data.result.quantity,
                price : data.result.price,
                price_includes_tax : (data.result.product?.price_includes_tax === true) || (data.result.price_includes_tax === true),
                unity : data.result.unity,
                purchase_price : data.result.purchase_price ? data.result.purchase_price : 0,
                vat :  data.result.vat ? data.result.vat : this.business.vat,
                total : data.result.total ? data.result.total : 0,
                sub_total : data.result.sub_total ? data.result.sub_total : 0,
                custom_product : false,
                create_catalog_product : false,
                custom_quantity_mode : false,
                custom_discount_mode : false,
                custom_vat_mode : false,
                variants: data.result.product.variants || [],
                variant_id: data.result.variant_id || null
            }}
            this.localData.products = [...this.localData.products]
        }
    },
    emitAutoCompleteClient(data){
        this.localData.client_id = data.result.id
        this.localData.client = data.result
    },
    openCreateClientModal(){
        this.createClientState = !this.createClientState
    },
    createClient(data){
        if(data.client){
            this.localData.client_id = data.client.id
            this.localData.client = data.client
        }
        if(data && data.state != undefined){
            this.createClientState = data.state
        }
    },
    checkIfValidProduct(){
        return this.localData.products.length > 0 && this.localData.products.every(product => (
            product.product_id != null
            || (product.custom_product === true && helper.richTextToPlainText(product.product_label).trim().length > 0)
        ))
    },
    sanitizeCustomProductLabels(){
        this.localData.products.forEach(product => {
            if (product.custom_product) {
                product.product_label = helper.sanitizeRichText(product.product_label)
            }
        })
    },
    async modalClosed(){
        if(this.draftAutosaveClosing) return
        this.draftAutosaveClosing = true
        await this.pauseDraftAutosave(this.draftAutosaveEligible)
        if(document.getElementById('close-modal-btn')){
            document.getElementById('close-modal-btn').click()
        }
        this.clearForm()
        this.$emit('modalClosed', true)
    },
    //helper functions
    formatDate(date,locale) { return helper.formatDate(date,locale) },
    formatMoney(number) { return helper.formatMoney(number);},
    formatReference(number,id) { return helper.formatReference(number,id);},
    onVariantChange(index){
        const product = this.localData.products[index];
        const variant = product.variants.find(v => v.id === product.variant_id);
        if(variant){
            product.price = variant.price;
            if(variant.inventory){
                 product.inventory_id = variant.inventory.id;
                 product.maxQty = variant.inventory.quantity;
            }
            this.calculatePrices();
        }
    }
  },
  async created(){
        let createdServerDraft = false
            
        if(this.localData.date) {
            this.localData.date = moment(this.localData.date).format('YYYY-MM-DD')
        }else{
            this.localData.date = moment().format('YYYY-MM-DD')
        }

        if(this.localData.status == "draft" || !this.localData.status){
            this.localData.status = 'pending'
        }
        this.calculatePrices()

        if(this.localData.products.length){
            for(let i = 0 ; i < this.localData.products.length ; i++){
                if(!this.localData.products[i].discount){
                    this.localData.products[i].discount = 0
                }
                this.$set(this.localData.products[i], 'create_catalog_product', false);
                const q = Number(this.localData.products[i].quantity);
                this.$set(this.localData.products[i], 'custom_quantity_mode', ![0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].includes(q));
                const d = Number(this.localData.products[i].discount);
                this.$set(this.localData.products[i], 'custom_discount_mode', ![0, 5, 10, 15, 20, 25, 30, 50].includes(d));
                const v = Number(this.localData.products[i].vat);
                this.$set(this.localData.products[i], 'custom_vat_mode', ![0, 5, 10, 20, 30].includes(v));
            }
        }

        // When creating, immediately create a draft on the server and keep its id/reference
        if(['create','transfer'].includes(this.action)){
            const { data } = await helper.customPost(`${process.env.VUE_APP_API}/orders/draft`,{})
            createdServerDraft = true
            this.localData.id = data.id
            this.localData.reference = data.reference
            if(data.date){
                this.localData.date = moment(data.date).format('YYYY-MM-DD')
            }
        }
        this.startDraftAutosave(
            createdServerDraft,
            ['create', 'transfer'].includes(this.action) || this.data?.status === 'draft'
        )
  }
}
</script>

<style scoped>
    .table-borderless>:not(caption)>*>*{
        padding: 5px !important
    }
    /* Mobile-only: cap products list height and enable inner scrolling */
    @media (max-width: 575.98px) {
        .products-scroll {
            max-height: 60vh;
            overflow-y: auto;
            -webkit-overflow-scrolling: touch;
            box-shadow: 1px 1px 2px 2px #ddd;
            margin-bottom: 10px;
            padding-top: 10px;
            background: #fdfdfd;
            border: 1px solid #ddd;
            height: 300px
        }
        .products-scroll .row {
            margin-left: 0;
            margin-right: 0;
        }
    }
</style>
